// extracted by mini-css-extract-plugin
export default {"container":"Hk-z","blurb":"Ik-z","links":"Jk-z"};